// Masks characters in a string.
// Params:
//     value (string)
//         The string to mask.
//     numUnmaskedChars (integer)
//         The number of unmasked characters to allow (default is 0).
//         A positive number will allow n unmasked characters at the beginning of the string. (e.g. '123***')
//         A negative number will allow n unmasked characters at the end of the string. (e.g. '***456')
//         0 will mask the entire string.
//     maskChar (string)
//         The character with which to mask each character in `value` (default is '*').
//

const maskStringValue = function (value, numUnmaskedChars = 0, maskChar = '*') {
  const chars = value.split('')
  const len = chars.length

  if (numUnmaskedChars > 0) {
    // Allow unmasked chars at the beginning of the string:
    return chars.reduce((str, char, idx) => {
      const limit = Math.min(numUnmaskedChars, len)
      const val = (idx >= limit) ? maskChar : char
      return `${str}${val}`
    }, '')
  } else {
    // Allow unmasked chars at the end of the string:
    return chars.reduce((str, char, idx) => {
      const limit = Math.max(len + numUnmaskedChars, 0)
      const val = (idx < limit || limit === 0) ? maskChar : char
      return `${str}${val}`
    }, '')
  }
}

export default maskStringValue



// WEBPACK FOOTER //
// ./src/util/MaskStringValue/index.js